<template>
    <div class="my-selection-helpers">
        <div v-if="!helperMySelectionStep1 && favoritesLength === 1" class="my-selection-helpers-step my-selection-helpers-step--1">
            <div class="my-selection-helpers-target my-selection-helpers-target--step-1">
                <div class="my-selection-helpers-target--step-1-inner">
                    <span class="material-icon icon-library_add"></span>
                    <div class="badge">{{ favoritesLength }}</div>
                </div>
            </div>
            <div class="my-selection-helpers-popup">
                <div class="my-selection-helpers-popup-text">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24Zm0-2.33A9.68,9.68,0,1,0,2.32,12,9.64,9.64,0,0,0,12,21.67Z"/>
                        <path d="M10.45,15.88V12.79h-.13c-.19,0-.37,0-.55,0a.55.55,0,0,1-.47-.52c0-.39,0-.78,0-1.17a.58.58,0,0,1,.62-.62h3a.59.59,0,0,1,.66.66c0,1.53,0,3.07,0,4.61,0,.13,0,.17.17.16s.25,0,.38,0a.58.58,0,0,1,.62.6q0,.56,0,1.11a.59.59,0,0,1-.63.61H9.92a.58.58,0,0,1-.62-.6c0-.37,0-.75,0-1.12a.57.57,0,0,1,.61-.6Z"/>
                        <path d="M12,9.38a2,2,0,1,1,2-2A2,2,0,0,1,12,9.38Z"/>
                    </svg>
                    <span>{{ $t('my_selection_helpers_step1_txt') }}</span>
                </div>
                <div class="my-selection-helpers-popup-footer">
                    <a href="#" @click.prevent="setMySelectionHelperStep('step-1')" class="btn btn-link text-uppercase">
                        {{ $t('my_selection_helpers_step1_btn') }}
                    </a>
                </div>
            </div>
        </div>
        <div v-else-if="!helperMySelectionStep2 && favoritesLength === 2" class="my-selection-helpers-step my-selection-helpers-step--2">
            <div class="my-selection-helpers-target my-selection-helpers-target--step-2">
                <div class="my-selection-helpers-target--step-2-inner mr-3">
                    <button v-if="favoritesLength" class="btn btn-icon-left btn-success text-uppercase">
                        <span class="material-icon icon-library_add"/>
                        {{ $tc('order_n_selected_photos', favoritesLength, {amount: favoritesLength}) }}
                    </button>
                    <div class="my-selection-helpers-popup">
                        <div class="my-selection-helpers-popup-text">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path d="M12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24Zm0-2.33A9.68,9.68,0,1,0,2.32,12,9.64,9.64,0,0,0,12,21.67Z"/>
                                <path d="M10.45,15.88V12.79h-.13c-.19,0-.37,0-.55,0a.55.55,0,0,1-.47-.52c0-.39,0-.78,0-1.17a.58.58,0,0,1,.62-.62h3a.59.59,0,0,1,.66.66c0,1.53,0,3.07,0,4.61,0,.13,0,.17.17.16s.25,0,.38,0a.58.58,0,0,1,.62.6q0,.56,0,1.11a.59.59,0,0,1-.63.61H9.92a.58.58,0,0,1-.62-.6c0-.37,0-.75,0-1.12a.57.57,0,0,1,.61-.6Z"/>
                                <path d="M12,9.38a2,2,0,1,1,2-2A2,2,0,0,1,12,9.38Z"/>
                            </svg>
                            <span>{{ $t('my_selection_helpers_step2_txt') }}</span>
                        </div>
                        <div class="my-selection-helpers-popup-footer">
                            <a href="#" @click.prevent="setMySelectionHelperStep('step-2')" class="btn btn-link text-uppercase">
                                {{ $t('my_selection_helpers_step2_btn') }}
                            </a>
                        </div>
                    </div>
                </div>
                <button v-if="album && +album.free_download" class="btn btn-icon-left btn-light text-uppercase">
                    <span class="material-icon icon-cloud_download"/>
                    {{ $t('download_album') }}
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .my-selection-helpers {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 2;

        &-step {
            position: absolute;

            &--1 {
                top: 123px;
                right: 164px;
            }

            &--2 {
                width: 100%;
                right: 0;
                bottom: 0;
            }
        }

        &-target {
            position: absolute;
            pointer-events: none;

            &--step-1 {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 80px;
                height: 80px;
                right: 0;
                top: -110px;
                border-radius: 50%;
                background-color: var(--bg-color);

                &-inner {
                    position: relative;

                    .badge {
                        position: absolute;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 18px;
                        height: 18px;
                        top: -10px;
                        right: -12px;
                        border-radius: 50%;
                        overflow: hidden;
                        color: #232323;
                        font-size: .8rem;
                        background-color: #eee;
                        pointer-events: none;
                        letter-spacing: 0;
                    }
                }
            }

            &--step-2 {
                display: flex;
                right: 41px;
                bottom: 60px;
                pointer-events: auto;

                &-inner {
                    position: relative;

                    .my-selection-helpers-popup {
                        position: absolute;
                        margin-bottom: 30px;
                        bottom: 100%;
                    }
                }

                .btn:not(.btn-link) {
                    pointer-events: none;
                }

                .btn-light {
                    opacity: 0;
                }
            }
        }

        &-popup {
            width: 540px;
            padding: 32px 35px 20px;
            right: 0;
            box-shadow: 0 12px 17px 2px rgba(#000, .14), 0 5px 22px 4px rgba(#000, .12), 0 7px 8px -4px rgba(#000, .2);
            background-color: var(--bg-color);

            &-text {
                display: flex;

                > svg {
                    fill: var(--text-color);
                    width: 30px;
                    height: 30px;
                    margin-right: 30px;
                }

                > span {
                    flex: 1;
                }
            }

            &-footer {
                margin-top: 15px;
                text-align: center;

                .btn {

                    &-link {
                        color: inherit;
                    }
                }
            }
        }
    }
</style>

<script>
  import helpersMySelection from 'src/mixins/helpersMySelectionComponent';

  export default {
    mixins: [helpersMySelection],
  };
</script>
